export default "__VITE_ASSET__FFxiB7Lf__"